import { Inject, Injectable } from '@angular/core';
import { Params, Router, RouterEvent, RoutesRecognized } from '@angular/router';
import { omit as _omit } from 'lodash';
import { force } from 'notie';
import { filter } from 'rxjs/operators';
import { LOCATION } from '../location';

const NOTIFY_REDIRECTION_KEY = 'notifyRedirection';

@Injectable({
  providedIn: 'root'
})
export class EsDomainCheckService {
  constructor(
    private router: Router,
    @Inject(LOCATION) private location: Location
  ) {}

  notifyIfRedirected(): void {
    this.router.events
      .pipe(
        filter((event: RouterEvent) => event instanceof RoutesRecognized),
        filter(
          (event: RoutesRecognized) =>
            event.state.root.queryParams[NOTIFY_REDIRECTION_KEY]
        )
      )
      .subscribe(event => {
        const queryParams: Params = _omit(
          event.state.root.queryParams,
          NOTIFY_REDIRECTION_KEY
        );
        const url: string = event.url.substring(0, event.url.indexOf('?'));
        this.router.navigateByUrl(url, { queryParams });
        this.notify();
      });
  }

  private notify(): void {
    const { protocol, host } = this.location;
    const url = `${protocol}//${host}`;
    force({
      type: 'warning',
      text: `<b>Notice:</b> You have been redirected to our new URL (<a href="${url}" target="_blank" style="color: white; text-decoration: underline; font-weight: bold;">${url}</a>), please save this URL in your browser to avoid any future inconvenience.`,
      buttonText: 'Ok'
    });
  }
}
